import React, { useEffect } from "react";

const eng_graph_1 = {
    width: 400,
    height: 465,
    viewBox: "0 0 400 465",
    titleLines: ["Rubber Production for", "Three Nations, 1950-1970"],
    xAxis: {
        label: "Year",
        positions: [155.70, 239.42, 323.14],
        labels: ["1950", "1960", "1970"],
    },
    yAxis: {
        positions: [72, 122, 172, 222, 272],
        labels: ["600", "480", "360", "240", "120"],
        axisLabel: ["Yearly rubber production", "(in thousands of tonnes)"],
    },
    legend: [
        { name: "Indonesia", style: "solid", markerType: "marker0" },
        { name: "Thailand", style: "dashed", markerType: "marker1" },
        { name: "Malaysia", style: "thickDashed", markerType: "marker2" },
    ],
    dataLines: [
        {
            series: "Indonesia",
            segments: [
                { x1: 155.70, y1: 230, x2: 239.42, y2: 160 },
                { x1: 239.42, y1: 160, x2: 323.14, y2: 90 },
            ],
        },
        {
            series: "Thailand",
            segments: [
                { x1: 155.70, y1: 250, x2: 239.42, y2: 190 },
                { x1: 239.42, y1: 190, x2: 323.14, y2: 100 },
            ],
        },
        {
            series: "Malaysia",
            segments: [
                { x1: 155.70, y1: 210, x2: 239.42, y2: 150 },
                { x1: 239.42, y1: 150, x2: 323.14, y2: 120 },
            ],
        },
    ],
};

const Set_eng_graph_1 = ({ graphData }) => {
    // graphData가 없으면 기본값(defaultGraphData)을 사용
    const {
        width,
        height,
        viewBox,
        titleLines,
        xAxis,
        yAxis,
        legend,
        dataLines,
    } = graphData || eng_graph_1;

    const renderDefs = () => (
        <defs>
            <marker
                id="marker0v1"
                markerWidth="6"
                markerHeight="6"
                refX="3"
                refY="3"
                markerUnits="strokeWidth"
            >
                <polygon points="3 0, 0 5.196, 6 5.196" fill="#000" />
            </marker>
            <marker
                id="marker1v1"
                markerWidth="5"
                markerHeight="5"
                refX="2.5"
                refY="2.5"
                markerUnits="strokeWidth"
            >
                <path
                    d="M0,0 L0,5 L5,5 L5,0 z"
                    fill="#BBB"
                    stroke="#000"
                    strokeWidth="1.5"
                />
            </marker>
            <marker
                id="marker2v1"
                markerWidth="6"
                markerHeight="6"
                refX="3"
                refY="3"
                markerUnits="strokeWidth"
            >
                <circle
                    cx="3"
                    cy="3"
                    r="1.8"
                    fill="#FFF"
                    stroke="#000"
                    strokeWidth="0.6"
                />
            </marker>
        </defs>
    );

    const renderHorizontalGrid = () =>
        yAxis.positions.map((y, idx) => (
            <g key={`hgrid-${idx}`}>
                <line
                    x1="113.84"
                    y1={y}
                    x2="365"
                    y2={y}
                    stroke="#000"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                />
                <line
                    x1="107.84"
                    y1={y}
                    x2="119.84"
                    y2={y}
                    stroke="#000"
                    strokeWidth="0.9"
                />
                <text
                    textAnchor="end"
                    x="101.84"
                    y={parseFloat(y) + 6}
                    fontFamily="Crimson Text"
                    fontSize="19.84"
                >
                    {yAxis.labels[idx]}
                </text>
            </g>
        ));

    const renderVerticalAxis = () =>
        xAxis.positions.map((x, idx) => (
            <g key={`vaxis-${idx}`}>
                <line
                    x1={x}
                    y1="72"
                    x2={x}
                    y2="272"
                    stroke="#000"
                    strokeWidth="0.9"
                />
                <text
                    x={x}
                    y="291.84"
                    textAnchor="middle"
                    fontFamily="Crimson Text"
                    fontSize="19.84"
                >
                    {xAxis.labels[idx]}
                </text>
            </g>
        ));

    const renderTitle = () =>
        titleLines.map((line, idx) => (
            <text
                key={`title-${idx}`}
                x="239.42"
                y={24 + idx * 24}
                textAnchor="middle"
                fontFamily="Crimson Text"
                fontSize="19.84"
            >
                {line}
            </text>
        ));

    const renderXAxisLabel = () => (
        <text
            x="239.42"
            y="325.68"
            textAnchor="middle"
            fontFamily="Crimson Text"
            fontSize="19.84"
        >
            {/* 예를 들어, xAxis.label이 "Year"라면 두 줄로 분리하려면 아래처럼 직접 문자열을 지정하거나, 배열로 관리할 수 있습니다. */}
            <tspan x="239.42" dy="0">Year (Time)</tspan>
        </text>
    );

    const renderYAxisLabel = () => (
        <g transform="translate(24,172) rotate(-90)">
            <text
                x="0"
                y="0"
                textAnchor="middle"
                fontFamily="Crimson Text"
                fontSize="19.84"
            >
                {yAxis.axisLabel[0]}
            </text>
            <text
                x="0"
                y="24"  // 여기서 24는 줄 간격, 필요에 따라 조정하세요.
                textAnchor="middle"
                fontFamily="Crimson Text"
                fontSize="19.84"
            >
                {yAxis.axisLabel[1]}
            </text>
        </g>
    );

    const renderLegend = () => (
        <g>
            <rect
                x="117.94"
                y="342.84"
                width="159.12"
                height="103"
                fill="none"
                stroke="#000"
                strokeWidth="0.9"
            />
            {legend.map((item, idx) => {
                let strokeDasharray = "";
                let strokeWidth = 2.4;
                if (item.style === "dashed") {
                    strokeDasharray = "9 6";
                } else if (item.style === "thickDashed") {
                    strokeDasharray = "1.1 6";
                    strokeWidth = 3;
                }
                const yPos = 359.84 + idx * 32;
                return (
                    <g key={`legend-${idx}`}>
                        <line
                            x1="124.94"
                            y1={yPos}
                            x2="151.94"
                            y2={yPos}
                            stroke="#000"
                            strokeWidth={strokeWidth}
                            strokeDasharray={strokeDasharray}
                            markerEnd={`url(#${item.markerType}v1)`}
                        />
                        <line
                            x1="151.94"
                            y1={yPos}
                            x2="178.94"
                            y2={yPos}
                            stroke="#000"
                            strokeWidth={strokeWidth}
                            strokeDasharray={strokeDasharray}
                            markerStart={`url(#${item.markerType}v1)`}
                        />
                        <text
                            x="188.94"
                            y={yPos + 7}
                            fontFamily="Crimson Text"
                            fontSize="19.84"
                        >
                            {item.name}
                        </text>
                    </g>
                );
            })}
        </g>
    );

    const renderDataLines = () =>
        dataLines.map((seriesItem, sIdx) => {
            const legendItem =
                legend.find((l) => l.name === seriesItem.series) || {};
            let strokeDasharray = "";
            let strokeWidth = 2.4;
            if (legendItem.style === "dashed") {
                strokeDasharray = "9 6";
            } else if (legendItem.style === "thickDashed") {
                strokeDasharray = "1.1 6";
                strokeWidth = 3;
            }
            const marker =
                legendItem.markerType !== undefined ? legendItem.markerType : "marker0";
            return seriesItem.segments.map((seg, idx) => (
                <line
                    key={`series-${sIdx}-seg-${idx}`}
                    x1={seg.x1}
                    y1={seg.y1}
                    x2={seg.x2}
                    y2={seg.y2}
                    stroke="#000"
                    strokeWidth={strokeWidth}
                    strokeDasharray={strokeDasharray}
                    markerStart={`url(#${marker}v1)`}
                    markerEnd={`url(#${marker}v1)`}
                />
            ));
        });

    return (
        <svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
            {renderDefs()}
            <g>
                {renderHorizontalGrid()}
                {renderYAxisLabel()}
                {renderVerticalAxis()}
                {renderTitle()}
                {renderXAxisLabel()}
                {renderLegend()}
                {renderDataLines()}
            </g>
        </svg>
    );
};

export { eng_graph_1, Set_eng_graph_1 };